export const updateIntegrationParameter = (parameters) => {
    if (parameters.get("beyondplay") === "true") {
        parameters.set("intergration", "beyondplay");
    }
};
